import moment from "moment";

export const formatUTC3 = (date: string) => moment.utc(date).utcOffset(180).format("YYYY-MM-DD HH:mm:ss");
